/**
 * @typedef {Object} RelayParams
 * @property {string} [first_name]
 * @property {string} [last_name]
 * @property {number} [gender]
 * @property {string} [tel]
 * @property {string} [login_id]
 * @property {string} [login_password]
 */

/**
 * @param {Object} data
 * @return {data is RelayParams}
 */
export const isRelayParams = data => {
  return (
    typeof data === 'object' &&
    data !== null &&
    'first_name' in data &&
    typeof data.first_name === 'string' &&
    'last_name' in data &&
    typeof data.last_name === 'string' &&
    'gender' in data &&
    typeof data.gender === 'number' &&
    'tel' in data &&
    typeof data.tel === 'string' &&
    'login_id' in data &&
    typeof data.login_id === 'string' &&
    'login_password' in data &&
    typeof data.login_password === 'string'
  )
}

/**
 *
 * @param {unknown} data
 * @returns {data is 1|2|3}
 */
export const isGenderNum = data => {
  if (typeof data === 'number') {
    return [1, 2, 3].includes(data)
  } else {
    return false
  }
}
/**
 *
 * @param {unknown} data
 * @returns {data is 1|2}
 */
export const isHumanitiesOrScienceNum = data => {
  if (typeof data === 'number') {
    return [1, 2].includes(data)
  } else {
    return false
  }
}
/**
 *
 * @param {unknown} data
 * @returns {data is number}
 */
export const isSchoolDepartmentNum = data => {
  return typeof data === 'number'
}
/**
 *
 * @param {unknown} data
 * @returns {data is number}
 */
export const isGraduationYearNum = data => {
  const currentMonth = new Date().getMonth() + 1
  const currentYear = currentMonth < 4 ? new Date().getFullYear() - 1 : new Date().getFullYear()
  const list = Array(8)
    .fill(0)
    .map((_, i) => i + currentYear)

  if (typeof data === 'number') {
    return list.includes(data)
  } else {
    return false
  }
}
/**
 *
 * @param {unknown} data
 * @returns {data is number}
 */
export const isGraduationMonthNum = data => {
  const list = Array(12)
    .fill(0)
    .map((_, i) => i + 1)

  if (typeof data === 'number') {
    return list.includes(data)
  } else {
    return false
  }
}
